define('lq/events/actions/deleteDynamicContentCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function DeleteDynamicContentCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(DeleteDynamicContentCommand, EventAction);

    DeleteDynamicContentCommand.typeName = 'DeleteDynamicContentCommand';

    DeleteDynamicContentCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    DeleteDynamicContentCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'DeleteDynamicContent',
            command: this.eventData.command
        };
    };

    return DeleteDynamicContentCommand;
});
